import angular from 'angular';

import ArrayUtilService from './array.util';
import TimeUtilService from './time.util';
import NumberUtilService from './number.util';
import EventUtilService from './event.util';

export * from './permission.util';
export * from './error.util';

export default angular
    .module('application.util', [])
    .service('arrayUtil', ArrayUtilService)
    .service('timeUtil', TimeUtilService)
    .service('numberUtil', NumberUtilService)
    .service('eventUtil', EventUtilService);



// WEBPACK FOOTER //
// ./src/application/util/index.js